import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "browse" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "hidden mt-32 w-1/4 xl:block" }
const _hoisted_4 = { class: "fixed" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ml-20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-primary" }, "Browse Store"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Fashions / Clothing")
], -1)
const _hoisted_6 = { class: "mt-10 ml-20" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "pt-1 mt-32 mb-10 xl:mx-12 core-container" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-6 gap-y-12 pb-24 md:grid-cols-3 md:gap-12 md:gap-y-24 xl:grid-cols-4 xl:gap-20 xl:gap-y-24 xl:mx-12 core-container" }

import { ref, onMounted, onUnmounted, watch } from "vue";

import ProductCard from "@/components/common/ProductCard.vue";
import SelectCategory from "@/components/SelectCategory.vue";

import { useFetchProducts } from "@/composables/use-fetch-products";
import { CategoryApi } from "@/api/category";
import { ICategory } from "@/interfaces/ICategory";
import { loadingWrapper } from "@/helpers/loading-wrapper";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { products, infiniteSrollFetchMore, resetPageMeta, refetchProducts } =
  useFetchProducts();

const categories = ref<ICategory[]>([{ id: 0, name: "All" }]);
const activeCategoryId = ref<number>(0);
const search = ref("");

const getParams = () => ({
  name: search.value,
  category: activeCategoryId.value || undefined,
});

/**
 * * Infinite Scrolling
 */
const infiniteScrollComponent = ref(null);
const handleInfiniteScroll = () => {
  if (infiniteScrollComponent.value) {
    const infiniteScrollComponentElement: Element =
      infiniteScrollComponent.value;

    let isInfiniteScrollReachedBottom =
      infiniteScrollComponentElement.getBoundingClientRect().bottom <
      window.innerHeight++;

    isInfiniteScrollReachedBottom && infiniteSrollFetchMore(getParams());
  }
};

const changeCategory = async (categoryId: number) => {
  loadingWrapper(async () => {
    resetPageMeta();
    activeCategoryId.value = categoryId;
    refetchProducts(getParams());
  });
};

watch(search, () => {
  setTimeout(() => {
    loadingWrapper(async () => {
      refetchProducts(getParams());
    });
  }, 750);
});

onMounted(async () => {
  categories.value.push(...(await CategoryApi.getCategories()));
  window.addEventListener("scroll", handleInfiniteScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleInfiniteScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: category.id ?? i,
                class: _normalizeClass(["my-5 cursor-pointer", 
                category.id === activeCategoryId.value &&
                'pl-2 border-l-4 border-primary'
              ]),
                onClick: () => changeCategory(category.id ?? 0)
              }, _toDisplayString(category.name), 11, _hoisted_7))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", {
        ref_key: "infiniteScrollComponent",
        ref: infiniteScrollComponent,
        class: "w-full"
      }, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            id: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            type: "text",
            class: "block mt-1 w-full rounded-sm border-gray-400 shadow-sm sm:text-sm focus:ring-primary focus:border-primary",
            placeholder: "Search"
          }, null, 512), [
            [_vModelText, search.value]
          ]),
          _createVNode(SelectCategory, {
            categories: categories.value,
            class: "mt-8 ml-auto w-full xl:hidden",
            onChange: _cache[1] || (_cache[1] = id => changeCategory(id))
          }, null, 8, ["categories"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product) => {
            return (_openBlock(), _createBlock(ProductCard, {
              key: product.id,
              product: product
            }, null, 8, ["product"]))
          }), 128))
        ])
      ], 512)
    ])
  ]))
}
}

})